import './preline-default.css'
import './style.scss'
import 'preline'
import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import './cart.js';
import './newsletter-form.js';

// Inizializzazione Preline con debug
document.addEventListener('DOMContentLoaded', () => {

    console.log('Vite + Tailwind CSS + Preline caricato nel Frontend!')

    setTimeout(() => {
        setupCustomMegaMenuBehavior();
    }, 100);

    // Thumbnails Slider
    const thumbnailsSlider = new Swiper('.thumbnails-slider', {
        spaceBetween: 10,
        slidesPerView: 4,
        watchSlidesProgress: true,
        breakpoints: {
            640: {
                slidesPerView: 5,
            }
        }
    });

    // Main Slider
    const mainSlider = new Swiper('.main-slider', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: thumbnailsSlider,
        },
        loop: true,
    });

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // ==================
    // SWIPER A11Y
    // ==================

    const a11yMessages = {
        it: {
            prevSlideMessage: "Slide precedente",
            nextSlideMessage: "Slide successiva",
            firstSlideMessage: "Questa è la prima slide",
            lastSlideMessage: "Questa è l'ultima slide",
            paginationBulletMessage: "Vai alla slide {{index}}",
            pauseAutoplayMessage: "Metti in pausa lo scorrimento automatico dello slider",
            resumeAutoplayMessage: "Riprendi lo scorrimento automatico dello slider",
            pauseButtonText: "Pausa Slider",
            resumeButtonText: "Riprendi Slider",
        },
        en: {
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            pauseAutoplayMessage: "Pause slider autoplay",
            resumeAutoplayMessage: "Resume slider autoplay",
            pauseButtonText: "Pause Slider",
            resumeButtonText: "Resume Slider",
        },
    };

    const currentLang = document.documentElement.lang.split('-')[0].toLowerCase() || "en";
    const messages = a11yMessages[currentLang] || a11yMessages["en"];
    if (document.querySelector('.hero-home-swipers-wrapper')) {

        const swiperHeroHomeCustomPag = JSON.parse(
            document.querySelector(".home-swiper-main-slider").dataset.slidesTitles
        );
        const swiperHeroHomeData = JSON.parse(
            document.querySelector(".home-swiper-main-slider").dataset.slidesData
        );

        const swiperHeroHome = new Swiper(".home-swiper-main-slider", {
            a11y: {
                enabled: true,
                prevSlideMessage: messages.prevSlideMessage,
                nextSlideMessage: messages.nextSlideMessage,
                firstSlideMessage: messages.firstSlideMessage,
                lastSlideMessage: messages.lastSlideMessage,
                paginationBulletMessage: messages.paginationBulletMessage,
            },
            slidesPerView: "auto",
            spaceBetween: 20,
            loop: true,
            speed: 1200,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            tabindex: 0,
            observer: true,
            observeParents: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            // initialSlide: 0,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    const slideData = swiperHeroHomeData[index];
                    const slideTitle = slideData.label;
                    const slideThumbnail = slideData.thumbnail;
                    const slideCaption = slideData.caption;

                    // Rimuovi tag HTML dal titolo per l'aria-label
                    const cleanTitle = slideTitle.replace(/<[^>]*>/g, ' ').trim();
                    const ariaLabel = messages.paginationBulletMessage.replace('{{index}}', index + 1) + ': ' + cleanTitle;

                    return (
                        '<span class="' +
                        className +
                        ' swiper-pagination-bullet-custom" role="button" aria-label="' +
                        ariaLabel +
                        '">' +
                        '<div class="bullet-image">' +
                        '<img src="' + slideThumbnail + '" alt="' + cleanTitle + '" loading="lazy">' +
                        '</div>' +
                        '<div class="bullet-content">' +
                        '<span class="bullet-title" aria-hidden="true">' +
                        slideTitle +
                        '</span>' +
                        '</div>' +
                        '</span>'
                    );
                },
            },
        });

        /*******  BACKUP VECCHIO SLIDER *******/

        // const thumbsSwiper = new Swiper('.home-swiper-thumbs-slider', {
        //     slidesPerView: 3,
        //     spaceBetween: 0,
        //     loop: true,  // Abilita loop anche per thumbs
        //     watchSlidesProgress: true,
        //     autoScrollOffset: 1,
        //     speed: 750,
        //     allowTouchMove: false,  // Disabilita swipe manuale
        // });

        // const mainSwiper = new Swiper('.home-swiper-main-slider', {
        //     autoplay: {
        //         delay: 3500,
        //         disableOnInteraction: false,
        //     },
        //     speed: 1500,
        //     loop: true,
        //     allowTouchMove: true,  // Disabilita swipe manuale
        //     breakpoints: {
        //         1280: {
        //             allowTouchMove: false,
        //         },
        //     },
        //     on: {
        //         slideChange: function() {
        //             thumbsSwiper.slideNext();
        //         }
        //     }
        // });

        // // Inizializza mostrando la seconda slide nel thumbsSwiper
        // thumbsSwiper.slideTo(1);
    }

    if (document.querySelector('.news-dual-swipers-wrapper')) {

        const newsImagesSwiper = new Swiper('.news-images-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: 'fade',
            crossFade: true,
            allowTouchMove: false,
            speed: 1000,
        });

        const newsContentSwiper = new Swiper('.news-content-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            allowTouchMove: true, // Permetti swipe sul contenuto
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 1000,
            pagination: {
                el: '.news-content-pagination',
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
            },
            on: {
                slideChange: function () {
                    console.log('Content slider cambiato a:', this.realIndex);
                    // Il content slider comanda l'images slider
                    if (newsImagesSwiper) {
                        newsImagesSwiper.slideTo(this.realIndex);
                    }
                }
            }
        });
    }

    // Realization Images Slider
    if (document.querySelector('.realization-images-slider')) {
        const realizationImagesSlider = new Swiper('.realization-images-slider', {
            modules: [Navigation],
            spaceBetween: 16,
            slidesPerView: 'auto', // Larghezza automatica basata sul contenuto
            centeredSlides: false,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.realization-slider-button-next',
                prevEl: '.realization-slider-button-prev',
            },
            scrollbar: {
                el: '.realization-slider-scrollbar',
                hide: false,
                draggable: true,
            },
            breakpoints: {
                320: {
                    spaceBetween: 12,
                },
                640: {
                    spaceBetween: 16,
                },
                1024: {
                    spaceBetween: 20,
                }
            },
            on: {
                slideChange: function () {
                    // Aggiorna lo stato dei pulsanti di navigazione se necessario
                    const prevBtn = document.querySelector('.realization-slider-button-prev');
                    const nextBtn = document.querySelector('.realization-slider-button-next');

                    if (prevBtn && nextBtn) {
                        prevBtn.disabled = this.isBeginning;
                        nextBtn.disabled = this.isEnd;
                    }
                }
            }
        });

        // Inizializza stato pulsanti
        const prevBtn = document.querySelector('.realization-slider-button-prev');
        const nextBtn = document.querySelector('.realization-slider-button-next');
        if (prevBtn && nextBtn) {
            prevBtn.disabled = realizationImagesSlider.isBeginning;
            nextBtn.disabled = realizationImagesSlider.isEnd;
        }
    }

    // Realizations Slider
    if (document.querySelector('.realizations-slider')) {
        const realizationsSlider = new Swiper('.realizations-slider', {
            modules: [Navigation],
            slidesPerView: 3,
            spaceBetween: 24,
            watchOverflow: true,
            navigation: {
                nextEl: '.realizations-slider-button-next',
                prevEl: '.realizations-slider-button-prev',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 24,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                }
            },
            on: {
                slideChange: function () {
                    // Aggiorna lo stato dei pulsanti di navigazione
                    const prevBtn = document.querySelector('.realizations-slider-button-prev');
                    const nextBtn = document.querySelector('.realizations-slider-button-next');

                    if (prevBtn && nextBtn) {
                        prevBtn.disabled = this.isBeginning;
                        nextBtn.disabled = this.isEnd;

                        // Aggiungi stili per pulsanti disabilitati
                        if (this.isBeginning) {
                            prevBtn.classList.add('opacity-50', 'cursor-not-allowed');
                        } else {
                            prevBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                        }

                        if (this.isEnd) {
                            nextBtn.classList.add('opacity-50', 'cursor-not-allowed');
                        } else {
                            nextBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                        }
                    }
                }
            }
        });

        // Inizializza stato pulsanti
        const prevBtn = document.querySelector('.realizations-slider-button-prev');
        const nextBtn = document.querySelector('.realizations-slider-button-next');
        if (prevBtn && nextBtn) {
            prevBtn.disabled = realizationsSlider.isBeginning;
            nextBtn.disabled = realizationsSlider.isEnd;

            if (realizationsSlider.isBeginning) {
                prevBtn.classList.add('opacity-50', 'cursor-not-allowed');
            }
            if (realizationsSlider.isEnd) {
                nextBtn.classList.add('opacity-50', 'cursor-not-allowed');
            }
        }
    }

    initMasonryGrid();

    if (document.querySelectorAll('.hs-select').length > 0) {
        HSSelect.autoInit();

        // w-full px-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200

        var selectElements = document.querySelectorAll('.hs-select');
        selectElements.forEach(function (select) {
            const hsSelect = new HSSelect(select, {
                placeholder: select.getAttribute('data-placeholder') || 'Seleziona opzioni',
                toggleTag: "<button type=\"button\" aria-expanded=\"false\"></button>",
                toggleClasses: "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex gap-x-2 text-nowrap w-full px-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-primary focus:border-transparent transition duration-200 bg-white",
                dropdownClasses: "dropdown-wrapper mt-2 z-50 w-full max-h-72 p-1 space-y-0.5 bg-white border border-gray-200 rounded-lg overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300",
                optionClasses: "py-2 px-4 w-full text-sm text-gray-800 cursor-pointer hover:bg-gray-100 rounded-lg focus:outline-hidden focus:bg-gray-100 option-item",
                optionTemplate: "<div class=\"flex justify-between items-center w-full\"><span data-title></span><span class=\"hidden hs-selected:block\"><svg class=\"shrink-0 size-3.5 text-primary\" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div>",
                extraMarkup: "<div class=\"absolute top-1/2 end-3 -translate-y-1/2\"><svg class=\"shrink-0 size-3.5 text-muted-foreground-1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m7 15 5 5 5-5\"/><path d=\"m7 9 5-5 5 5\"/></svg></div>"
            });
        });
    }

})


function setupCustomMegaMenuBehavior() {
    const navbar = document.getElementById('main-navbar');

    // Funzione per controllare se c'è almeno un mega menu aperto
    function checkMegaMenuState() {
        // Cerchiamo sia .hs-dropdown-open che .open per coprire tutti i casi
        const openDropdowns = document.querySelectorAll('.hs-dropdown-open, .hs-dropdown.open');

        const hasMegaMenuOpen = Array.from(openDropdowns).some(dropdown => {
            const toggle = dropdown.querySelector('.hs-dropdown-toggle');
            return toggle && (
                toggle.id.includes('categorie') ||
                toggle.id.includes('sport') ||
                toggle.id.includes('eventi')
            );
        });

        if (hasMegaMenuOpen) {
            navbar.classList.add('navbar-mega-open');

            // Blocca lo scroll del body
            document.body.classList.add('overflow-hidden');

            // Aggiungi backdrop se non esiste già
            if (!document.getElementById('mega-menu-backdrop')) {
                const backdrop = document.createElement('div');
                backdrop.id = 'mega-menu-backdrop';
                backdrop.style.position = 'fixed';
                backdrop.style.top = '0';
                backdrop.style.left = '0';
                backdrop.style.width = '100vw';
                backdrop.style.height = '100vh';
                backdrop.style.zIndex = '40'; // Sotto la navbar (z-50) ma sopra il contenuto
                backdrop.style.background = 'rgba(19,19,42,0.4)';
                backdrop.style.backdropFilter = 'blur(8px) saturate(1.5)';
                backdrop.style.webkitBackdropFilter = 'blur(8px) saturate(1.5)';
                backdrop.style.transition = 'opacity 0.3s';
                backdrop.style.opacity = '1';
                backdrop.style.pointerEvents = 'auto';
                document.body.appendChild(backdrop);

                // Chiudi dropdown SOLO cliccando sul backdrop (non sui menu)
                backdrop.addEventListener('click', (e) => {
                    // Assicurati che il click sia proprio sul backdrop e non su elementi figli
                    if (e.target === backdrop) {
                        document.querySelectorAll('.hs-dropdown-open, .hs-dropdown.open').forEach(dropdown => {
                            const toggle = dropdown.querySelector('.hs-dropdown-toggle');
                            if (toggle && (
                                toggle.id.includes('categorie') ||
                                toggle.id.includes('sport') ||
                                toggle.id.includes('eventi')
                            )) {
                                toggle.click();
                            }
                        });
                    }
                });
            }
        } else {
            navbar.classList.remove('navbar-mega-open');

            // Rimuovi il blocco dello scroll
            document.body.classList.remove('overflow-hidden');

            // Rimuovi backdrop se presente
            const backdrop = document.getElementById('mega-menu-backdrop');
            if (backdrop) {
                backdrop.style.opacity = '0';
                setTimeout(() => {
                    if (backdrop.parentNode) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                }, 300);
            }
        }
    }

    // Osserva i cambiamenti nel DOM per rilevare apertura/chiusura dropdown
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const element = mutation.target;
                if (element.classList.contains('hs-dropdown')) {
                    // Un dropdown ha cambiato stato, controlla se è un mega menu
                    setTimeout(checkMegaMenuState, 50);
                }
            }
        });
    });

    // Inizia ad osservare tutti i dropdown
    document.querySelectorAll('.hs-dropdown').forEach(dropdown => {
        observer.observe(dropdown, {
            attributes: true,
            attributeFilter: ['class']
        });
    });

    // Gestione ESC per chiudere tutti i mega menu
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.hs-dropdown-open, .hs-dropdown.open').forEach(dropdown => {
                const toggle = dropdown.querySelector('.hs-dropdown-toggle');
                if (toggle && (
                    toggle.id.includes('categorie') ||
                    toggle.id.includes('sport') ||
                    toggle.id.includes('eventi')
                )) {
                    toggle.click();
                }
            });
        }
    });

    // Controlla stato iniziale
    checkMegaMenuState();

    // Gestione accordion dentro mega menu - previeni chiusura del mega menu
    // Intercetta i click sui toggle degli accordion e segna l'evento per il dropdown
    document.querySelectorAll('.hs-dropdown-menu .hs-accordion-toggle').forEach(accordionToggle => {
        accordionToggle.addEventListener('click', function (e) {
            // Aggiungi un flag per indicare che questo è un click interno valido
            e._accordionClick = true;
        });
    });

    // Intercetta i click sul dropdown per ignorare quelli provenienti dagli accordion
    document.querySelectorAll('.hs-dropdown').forEach(dropdown => {
        const dropdownMenu = dropdown.querySelector('.hs-dropdown-menu');
        if (dropdownMenu && dropdownMenu.querySelector('.hs-accordion-toggle')) {
            dropdownMenu.addEventListener('click', function (e) {
                // Se è un click su accordion o nei suoi figli, non chiudere il dropdown
                if (e.target.closest('.hs-accordion-toggle') || e._accordionClick) {
                    e.stopPropagation();
                }
            });
        }
    });
}

// Gestisci tutti i pulsanti di incremento
document.querySelectorAll('[data-quantity="increase"]').forEach(button => {
    button.addEventListener('click', function () {
        const input = this.parentElement.querySelector('input[type="number"]');
        let currentValue = parseInt(input.value);
        input.value = currentValue + 1;
    });
});

// Gestisci tutti i pulsanti di decremento
document.querySelectorAll('[data-quantity="decrease"]').forEach(button => {
    button.addEventListener('click', function () {
        const input = this.parentElement.querySelector('input[type="number"]');
        let currentValue = parseInt(input.value);
        if (currentValue > 1) {
            input.value = currentValue - 1;
        }
    });
});

function initMasonryGrid() {
    const masonryContainer = document.querySelector('#realization-masonry');

    if (!masonryContainer) return;

    // Inizializza Masonry
    const msnry = new Masonry(masonryContainer, {
        itemSelector: '.masonry-item',
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        percentPosition: true,
    });

    // Usa imagesLoaded per aspettare il caricamento delle immagini
    imagesLoaded(masonryContainer, function () {
        // Dopo che tutte le immagini sono caricate, calcola aspect ratio e aggiungi classi
        document.querySelectorAll('.masonry-item').forEach(item => {
            const img = item.querySelector('img');
            if (img) {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                const aspectRatio = width / height;
                if (aspectRatio >= (16 / 9)) {
                    item.classList.add('masonry-item--width2');
                }
            }
        });

        // Ricalcola il layout di Masonry dopo aver aggiunto le classi
        msnry.layout();
    });
}